module.exports = __webpack_public_path__ + "img/zfr4.b2e99e38.jpg";